import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import { Provider } from "react-redux";

import { RouterProvider } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";
import router from "./router";
import { store } from "./store";
import { ThemeProvider } from "@mui/material";
import { theme } from "./utils/theme";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <PrimeReactProvider value={{ unstyled: false }}>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <RouterProvider router={router} />
            </ThemeProvider>
        </Provider>
    </PrimeReactProvider>
);
